import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import { useEffect } from "react";
import axios from "axios";
import apiUrl from "../../Environment/Api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ClientDetails() {
  useEffect(() => {
    getdata();
  }, []);
  const toaster = () => {
    toast.success("Data submitted successfully!", {
      autoClose: 3000,
      hideProgressBar: true,
      className: "toaster",
    });
  };

  const toasterupdate = () => {
    toast.success("Data Updated successfully!", {
      autoClose: 3000,
      hideProgressBar: true,
      className: "toast-warning1", // Apply a warning class
    });
  };

  const toasterdelete = () => {
    toast.success("Data Deleted successfully!", {
      autoClose: 3000,
      hideProgressBar: true,
      className: "toast-error", // Apply an error class
    });
  };

  const [showModal, setShowModal] = useState(false);

  const [formData, setFormData] = useState({
    clientName: "",
    email: "",
    mobile: "",
    countrycode: "",
    address: "",
    country: "",
  });

  const handleNewButtonClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  // post
  const handlesubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(apiUrl + "/clientdetails", formData);
      console.log("posted", response);
      setFormData({
        clientName: "",
        email: "",
        mobile: "",
        countrycode: "",
        address: "",
        country: "",
      });
      getdata();
      handleCloseModal();
      toaster();
    } catch (err) {
      console.log("error", err);
    }
  };

  //get
  const [getData, setData] = useState([]);
  const getdata = async () => {
    try {
      const response = await axios.get(apiUrl + "/clientdetailsfull");
      setData(response.data);
      setFilteredData(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  // search filter
  const [filteredData, setFilteredData] = useState([]);
  const handlesearchFilter = (e) => {
    e.preventDefault();
    const inputValue = e.target.value.trim().toLowerCase();
    const filteredData = getData.filter((data) =>
      Object.values(data).some((value) =>
        value.toString().toLowerCase().includes(inputValue)
      )
    );
    setFilteredData(filteredData);
    setCurrentPage(1);
  };

  //update
  const [showModal1, setShowModal1] = useState(false);
  const handleCloseModal1 = () => {
    setShowModal1(false);
  };
  const [formData1, setFormData1] = useState({
    clientName: "",
    email: "",
    mobile: "",
    countrycode: "",
    address: "",
    country: "",
  });

  const handleupdatesubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(
        apiUrl + `/clientdetails/${clientid}`,
        formData1
      );
      console.log("posted", response);
      setFormData({
        clientName: "",
        email: "",
        mobile: "",
        countrycode: "",
        address: "",
        country: "",
      });
      handleCloseModal1();
      getdata();
      toasterupdate();
    } catch (err) {
      console.log("error", err);
    }
  };

  const [clientid, setclientid] = useState("");
  function handleEdit(id) {
    const clienttoUpdate = getData.find((item) => item.id === id);
    setclientid(clienttoUpdate.id);

    setFormData1({
      clientName: clienttoUpdate.clientName,
      email: clienttoUpdate.email,
      mobile: clienttoUpdate.mobile,
      countrycode: clienttoUpdate.countrycode,
      address: clienttoUpdate.address,
      country: clienttoUpdate.country,
    });
    setShowModal1(true);
  }

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeleteModalname, setShowDeleteModalname] = useState("");
  const [getDeleteId, setDeleteId] = useState(false);
  const handledeletepopup = (id, name) => {
    setShowDeleteModalname(name);
    setShowDeleteModal(true);
    setDeleteId(id);
  };
  const handledeleteclose = () => {
    setShowDeleteModal(false);
  };

  //delete
  const handledelete = async (id) => {
    try {
      const response = await axios.delete(
        apiUrl + `/clientdetails/${getDeleteId}`
      );
      console.log(response);
      getdata();
      toasterdelete();
    } catch (error) {
      console.log(error);
    }
    setShowDeleteModal(false);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData
    .slice()
    .reverse()
    .slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleItemsPerPageChange = (e) => {
    setCurrentPage(1);
    setItemsPerPage(Number(e.target.value));
  };

  return (
    <div>
      <ToastContainer />
      <div className="d-flex">
        <h5 className="mt-2">Client Details</h5>
        <button
          className="btn  btn-success mx-3 addbutton-heading"
          onClick={handleNewButtonClick}
        >
          ADD
        </button>
      </div>
      <div>
        <Modal className="modal" show={showModal} onHide={handleCloseModal}>
          <form onSubmit={handlesubmit}>
            <Modal.Header closeButton>
              <Modal.Title>Add Client</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <label className="form-label">
                <b>Client Name:</b>
              </label>
              <input
                className="form-control"
                type="text"
                name="clientName"
                value={formData.clientName}
                onChange={(e) =>
                  setFormData({ ...formData, clientName: e.target.value })
                }
                placeholder="Enter Client Name"
                required
              />
              <label className="form-label pt-2">
                <b>Email:</b>
              </label>
              <input
                className="form-control"
                type="email"
                name="email"
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                placeholder="Enter Email"
              />
              <label className="form-label">
                <b>Mobile:</b>
              </label>
              <div className="input-group">
                <div className="input-group-append">
                  <select
                    value={formData.countrycode}
                    onChange={(e) =>
                      setFormData({ ...formData, countrycode: e.target.value })
                    }
                    style={{ width: "145px" }}
                    className="form-select"
                    id="phone"
                    name="countryCode"
                  >
                    <option value="">CountryCode</option>
                    <option value="1">United States +1</option>
                    <option value="44">United Kingdom +44</option>
                    <option value="61">Australia +61</option>
                    <option value="91">India +91</option>
                    <option value="31">Netherlands +31</option>
                    <option value="599">Netherlands Antilles +599</option>
                    <option value="93">+93 Afghanistan</option>
                    <option value="358">Aland Islands +358</option>
                    <option value="355">Albania +355</option>
                    <option value="213">Algeria +213</option>
                    <option value="1684">American Samoa +1684</option>
                    <option value="376">Andorra +376</option>
                    <option value="244">Angola +244</option>
                    <option value="1264">Anguilla +1264</option>
                    <option value="672">Antarctica +672</option>
                    <option value="1268">Antigua and Barbuda +1268</option>
                    <option value="54">Argentina +54</option>
                    <option value="374">Armenia +374</option>
                    <option value="297">Aruba +297</option>
                    <option value="61">Australia +61</option>
                    <option value="43">Austria +43</option>
                    <option value="994">Azerbaijan +994</option>
                    <option value="1242">Bahamas +1242</option>
                    <option value="973">Bahrain +973</option>
                    <option value="880">Bangladesh +880</option>
                    <option value="1246">Barbados +1246</option>
                    <option value="375">Belarus +375</option>
                    <option value="32">Belgium +32</option>
                    <option value="501">Belize +501</option>
                    <option value="229">Benin +229</option>
                    <option value="1441">Bermuda +1441</option>
                    <option value="975">Bhutan +975</option>
                    <option value="591">Bolivia +591</option>
                    <option value="599">
                      Bonaire, Sint Eustatius and Saba +599
                    </option>
                    <option value="387">Bosnia and Herzegovina +387</option>
                    <option value="267">Botswana +267</option>
                    <option value="55">Bouvet Island +55</option>
                    <option value="55">Brazil +55</option>
                    <option value="246">
                      British Indian Ocean Territory +246
                    </option>
                    <option value="673">Brunei Darussalam +673</option>
                    <option value="359">Bulgaria +359</option>
                    <option value="226">Burkina Faso +226</option>
                    <option value="257">Burundi +257</option>
                    <option value="855">Cambodia +855</option>
                    <option value="237">Cameroon +237</option>
                    <option value="1">Canada +1</option>
                    <option value="238">Cape Verde +238</option>
                    <option value="1345">Cayman Islands +1345</option>
                    <option value="236">Central African Republic +236</option>
                    <option value="235">Chad +235</option>
                    <option value="56">Chile +56</option>
                    <option value="86">China +86</option>
                    <option value="61">Christmas Island +61</option>
                    <option value="672">Cocos (Keeling) Islands +672</option>
                    <option value="57">Colombia +57</option>
                    <option value="269">Comoros +269</option>
                    <option value="242">Congo +242</option>
                    <option value="242">
                      Congo, Democratic Republic of the Congo +242
                    </option>
                    <option value="682">Cook Islands +682</option>
                    <option value="506">Costa Rica +506</option>
                    <option value="225">Cote D'Ivoire +225</option>
                    <option value="385">Croatia +385</option>
                    <option value="53">Cuba +53</option>
                    <option value="599">Curacao +599</option>
                    <option value="357">Cyprus +357</option>
                    <option value="420">Czech Republic +420</option>
                    <option value="45">Denmark +45</option>
                    <option value="253">Djibouti +253</option>
                    <option value="1767">Dominica +1767</option>
                    <option value="1809">Dominican Republic +1809</option>
                    <option value="593">Ecuador +593</option>
                    <option value="20">Egypt +20</option>
                    <option value="503">El Salvador +503</option>
                    <option value="240">Equatorial Guinea +240</option>
                    <option value="291">Eritrea +291</option>
                    <option value="372">Estonia +372</option>
                    <option value="251">Ethiopia +251</option>
                    <option value="500">
                      Falkland Islands (Malvinas) +500
                    </option>
                    <option value="298">Faroe Islands +298</option>
                    <option value="679">Fiji +679</option>
                    <option value="358">Finland +358</option>
                    <option value="33">France +33</option>
                    <option value="594">French Guiana +594</option>
                    <option value="689">French Polynesia +689</option>
                    <option value="262">
                      French Southern Territories +262
                    </option>
                    <option value="241">Gabon +241</option>
                    <option value="220">Gambia +220</option>
                    <option value="995">Georgia +995</option>
                    <option value="49">Germany +49</option>
                    <option value="233">Ghana +233</option>
                    <option value="350">Gibraltar +350</option>
                    <option value="30">Greece +30</option>
                    <option value="299">Greenland +299</option>
                    <option value="1473">Grenada +1473</option>
                    <option value="590">Guadeloupe +590</option>
                    <option value="1671">Guam +1671</option>
                    <option value="502">Guatemala +502</option>
                    <option value="44">Guernsey +44</option>
                    <option value="224">Guinea +224</option>
                    <option value="245">Guinea-Bissau +245</option>
                    <option value="592">Guyana +592</option>
                    <option value="509">Haiti +509</option>
                    <option value="39">
                      Holy See (Vatican City State) +39
                    </option>
                    <option value="504">Honduras +504</option>
                    <option value="852">Hong Kong +852</option>
                    <option value="36">Hungary +36</option>
                    <option value="354">Iceland +354</option>

                    <option value="62">Indonesia +62</option>
                    <option value="98">Iran, Islamic Republic of +98</option>
                    <option value="964">Iraq +964</option>
                    <option value="353">Ireland +353</option>
                    <option value="44">Isle of Man +44</option>
                    <option value="972">Israel +972</option>
                    <option value="39">Italy +39</option>
                    <option value="1876">Jamaica +1876</option>
                    <option value="81">Japan +81</option>
                    <option value="44">Jersey +44</option>
                    <option value="962">Jordan +962</option>
                    <option value="7">Kazakhstan +7</option>
                    <option value="254">Kenya +254</option>
                    <option value="686">Kiribati +686</option>
                    <option value="850">
                      Korea, Democratic People's Republic of +850
                    </option>
                    <option value="82">Korea, Republic of +82</option>
                    <option value="383">Kosovo +383</option>
                    <option value="965">Kuwait +965</option>
                    <option value="996">Kyrgyzstan +996</option>
                    <option value="856">
                      Lao People's Democratic Republic +856
                    </option>
                    <option value="371">Latvia +371</option>
                    <option value="961">Lebanon +961</option>
                    <option value="266">Lesotho +266</option>
                    <option value="231">Liberia +231</option>
                    <option value="218">Libyan Arab Jamahiriya +218</option>
                    <option value="423">Liechtenstein +423</option>
                    <option value="370">Lithuania +370</option>
                    <option value="352">Luxembourg +352</option>
                    <option value="853">Macao +853</option>
                    <option value="389">
                      Macedonia, the Former Yugoslav Republic of +389
                    </option>
                    <option value="261">Madagascar +261</option>
                    <option value="265">Malawi +265</option>
                    <option value="60">Malaysia +60</option>
                    <option value="960">Maldives +960</option>
                    <option value="223">Mali +223</option>
                    <option value="356">Malta +356</option>
                    <option value="692">Marshall Islands +692</option>
                    <option value="596">Martinique +596</option>
                    <option value="222">Mauritania +222</option>
                    <option value="230">Mauritius +230</option>
                    <option value="262">Mayotte +262</option>
                    <option value="52">Mexico +52</option>
                    <option value="691">
                      Micronesia, Federated States of +691
                    </option>
                    <option value="373">Moldova, Republic of +373</option>
                    <option value="377">Monaco +377</option>
                    <option value="976">Mongolia +976</option>
                    <option value="382">Montenegro +382</option>
                    <option value="1664">Montserrat +1664</option>
                    <option value="212">Morocco +212</option>
                    <option value="258">Mozambique +258</option>
                    <option value="95">Myanmar +95</option>
                    <option value="264">Namibia +264</option>
                    <option value="674">Nauru +674</option>
                    <option value="977">Nepal +977</option>
                    <option value="31">Netherlands +31</option>
                    <option value="599">Netherlands Antilles +599</option>
                    <option value="687">New Caledonia +687</option>
                    <option value="64">New Zealand +64</option>
                    <option value="505">Nicaragua +505</option>
                    <option value="227">Niger +227</option>
                    <option value="234">Nigeria +234</option>
                    <option value="683">Niue +683</option>
                    <option value="672">Norfolk Island +672</option>
                    <option value="1670">Northern Mariana Islands +1670</option>
                    <option value="47">Norway +47</option>
                    <option value="968">Oman +968</option>
                    <option value="92">Pakistan +92</option>
                    <option value="680">Palau +680</option>
                    <option value="970">
                      Palestinian Territory, Occupied +970
                    </option>
                    <option value="507">Panama +507</option>
                    <option value="675">Papua New Guinea +675</option>
                    <option value="595">Paraguay +595</option>
                    <option value="51">Peru +51</option>
                    <option value="63">Philippines +63</option>
                    <option value="64">Pitcairn +64</option>
                    <option value="48">Poland +48</option>
                    <option value="351">Portugal +351</option>
                    <option value="1787">Puerto Rico +1787</option>
                    <option value="974">Qatar +974</option>
                    <option value="262">Reunion +262</option>
                    <option value="40">Romania +40</option>
                    <option value="7">Russian Federation +7</option>
                    <option value="250">Rwanda +250</option>
                    <option value="590">Saint Barthelemy +590</option>
                    <option value="290">Saint Helena +290</option>
                    <option value="1869">Saint Kitts and Nevis +1869</option>
                    <option value="1758">Saint Lucia +1758</option>
                    <option value="590">Saint Martin +590</option>
                    <option value="508">Saint Pierre and Miquelon +508</option>
                    <option value="1784">
                      Saint Vincent and the Grenadines +1784
                    </option>
                    <option value="684">Samoa +684</option>
                    <option value="378">San Marino +378</option>
                    <option value="239">Sao Tome and Principe +239</option>
                    <option value="966">Saudi Arabia +966</option>
                    <option value="221">Senegal +221</option>
                    <option value="381">Serbia +381</option>
                    <option value="381">Serbia and Montenegro +381</option>
                    <option value="248">Seychelles +248</option>
                    <option value="232">Sierra Leone +232</option>
                    <option value="65">Singapore +65</option>
                    <option value="721">Sint Maarten +721</option>
                    <option value="421">Slovakia +421</option>
                    <option value="386">Slovenia +386</option>
                    <option value="677">Solomon Islands +677</option>
                    <option value="252">Somalia +252</option>
                    <option value="27">South Africa +27</option>
                    <option value="500">
                      South Georgia and the South Sandwich Islands +500
                    </option>
                    <option value="211">South Sudan +211</option>
                    <option value="34">Spain +34</option>
                    <option value="94">Sri Lanka +94</option>
                    <option value="249">Sudan +249</option>
                    <option value="597">Suriname +597</option>
                    <option value="47">Svalbard and Jan Mayen +47</option>
                    <option value="268">Swaziland +268</option>
                    <option value="46">Sweden +46</option>
                    <option value="41">Switzerland +41</option>
                    <option value="963">Syrian Arab Republic +963</option>
                    <option value="886">Taiwan, Province of China +886</option>
                    <option value="992">Tajikistan +992</option>
                    <option value="255">
                      Tanzania, United Republic of +255
                    </option>
                    <option value="66">Thailand +66</option>
                    <option value="670">Timor-Leste +670</option>
                    <option value="228">Togo +228</option>
                    <option value="690">Tokelau +690</option>
                    <option value="676">Tonga +676</option>
                    <option value="1868">Trinidad and Tobago +1868</option>
                    <option value="216">Tunisia +216</option>
                    <option value="90">Turkey +90</option>
                    <option value="7370">Turkmenistan +7370</option>
                    <option value="1649">Turks and Caicos Islands +1649</option>
                    <option value="688">Tuvalu +688</option>
                    <option value="256">Uganda +256</option>
                    <option value="380">Ukraine +380</option>
                    <option value="971">United Arab Emirates +971</option>

                    <option value="1">
                      United States Minor Outlying Islands +1
                    </option>
                    <option value="598">Uruguay +598</option>
                    <option value="998">Uzbekistan +998</option>
                    <option value="678">Vanuatu +678</option>
                    <option value="58">Venezuela +58</option>
                    <option value="84">Viet Nam +84</option>
                    <option value="1284">Virgin Islands, British +1284</option>
                    <option value="1340">Virgin Islands, U.s. +1340</option>
                    <option value="681">Wallis and Futuna +681</option>
                    <option value="212">Western Sahara +212</option>
                    <option value="967">Yemen +967</option>
                    <option value="260">Zambia +260</option>
                    <option value="263">Zimbabwe +263</option>
                  </select>
                </div>

                <input
                  className="form-control"
                  type="tel"
                  name="mobile"
                  value={formData.mobile}
                  maxLength={10}
                  onChange={(e) => {
                    const mobile = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 10);
                    setFormData({ ...formData, mobile: mobile });
                  }}
                  placeholder="Enter Mobile"
                />
              </div>
              <label className="form-label pt-2">
                <b>Address:</b>
              </label>
              <input
                className="form-control"
                type="text"
                name="address"
                value={formData.address}
                onChange={(e) =>
                  setFormData({ ...formData, address: e.target.value })
                }
                placeholder="Enter Address"
                required
              />
              <label className="form-label pt-2">
                <b>Country:</b>
              </label>
              <input
                className="form-control"
                type="text"
                name="country"
                value={formData.country}
                onChange={(e) =>
                  setFormData({ ...formData, country: e.target.value })
                }
                placeholder="Enter Country"
                required
              />
            </Modal.Body>

            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseModal}>
                Close
              </Button>
              <Button variant="primary" type="submit">
                Submit
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>

      {/* //update */}
      <Modal className="modal" show={showModal1} onHide={handleCloseModal1}>
        <form onSubmit={handleupdatesubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Client</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <label className="form-label">
              <b>Client Name:</b>
            </label>
            <input
              className="form-control"
              type="text"
              name="clientName"
              value={formData1.clientName}
              onChange={(e) =>
                setFormData1({ ...formData1, clientName: e.target.value })
              }
              placeholder="Enter Client Name"
              required
            />
            <label className="form-label pt-2">
              <b>Email:</b>
            </label>
            <input
              className="form-control"
              type="email"
              name="email"
              value={formData1.email}
              onChange={(e) =>
                setFormData1({ ...formData1, email: e.target.value })
              }
              placeholder="Enter Email"
            />
            <label className="form-label">
              <b>Mobile:</b>
            </label>
            <div className="input-group">
              <div className="input-group-append">
                <select
                  value={formData1.countrycode}
                  onChange={(e) =>
                    setFormData1({ ...formData1, countrycode: e.target.value })
                  }
                  style={{ width: "145px" }}
                  className="form-select"
                  id="phone"
                  name="countryCode"
                >
                  <option value="">CountryCode</option>
                  <option value="1">United States +1</option>
                  <option value="44">United Kingdom +44</option>
                  <option value="61">Australia +61</option>
                  <option value="91">India +91</option>
                  <option value="31">Netherlands +31</option>
                  <option value="599">Netherlands Antilles +599</option>
                  <option value="93">+93 Afghanistan</option>
                  <option value="358">Aland Islands +358</option>
                  <option value="355">Albania +355</option>
                  <option value="213">Algeria +213</option>
                  <option value="1684">American Samoa +1684</option>
                  <option value="376">Andorra +376</option>
                  <option value="244">Angola +244</option>
                  <option value="1264">Anguilla +1264</option>
                  <option value="672">Antarctica +672</option>
                  <option value="1268">Antigua and Barbuda +1268</option>
                  <option value="54">Argentina +54</option>
                  <option value="374">Armenia +374</option>
                  <option value="297">Aruba +297</option>
                  <option value="61">Australia +61</option>
                  <option value="43">Austria +43</option>
                  <option value="994">Azerbaijan +994</option>
                  <option value="1242">Bahamas +1242</option>
                  <option value="973">Bahrain +973</option>
                  <option value="880">Bangladesh +880</option>
                  <option value="1246">Barbados +1246</option>
                  <option value="375">Belarus +375</option>
                  <option value="32">Belgium +32</option>
                  <option value="501">Belize +501</option>
                  <option value="229">Benin +229</option>
                  <option value="1441">Bermuda +1441</option>
                  <option value="975">Bhutan +975</option>
                  <option value="591">Bolivia +591</option>
                  <option value="599">
                    Bonaire, Sint Eustatius and Saba +599
                  </option>
                  <option value="387">Bosnia and Herzegovina +387</option>
                  <option value="267">Botswana +267</option>
                  <option value="55">Bouvet Island +55</option>
                  <option value="55">Brazil +55</option>
                  <option value="246">
                    British Indian Ocean Territory +246
                  </option>
                  <option value="673">Brunei Darussalam +673</option>
                  <option value="359">Bulgaria +359</option>
                  <option value="226">Burkina Faso +226</option>
                  <option value="257">Burundi +257</option>
                  <option value="855">Cambodia +855</option>
                  <option value="237">Cameroon +237</option>
                  <option value="1">Canada +1</option>
                  <option value="238">Cape Verde +238</option>
                  <option value="1345">Cayman Islands +1345</option>
                  <option value="236">Central African Republic +236</option>
                  <option value="235">Chad +235</option>
                  <option value="56">Chile +56</option>
                  <option value="86">China +86</option>
                  <option value="61">Christmas Island +61</option>
                  <option value="672">Cocos (Keeling) Islands +672</option>
                  <option value="57">Colombia +57</option>
                  <option value="269">Comoros +269</option>
                  <option value="242">Congo +242</option>
                  <option value="242">
                    Congo, Democratic Republic of the Congo +242
                  </option>
                  <option value="682">Cook Islands +682</option>
                  <option value="506">Costa Rica +506</option>
                  <option value="225">Cote D'Ivoire +225</option>
                  <option value="385">Croatia +385</option>
                  <option value="53">Cuba +53</option>
                  <option value="599">Curacao +599</option>
                  <option value="357">Cyprus +357</option>
                  <option value="420">Czech Republic +420</option>
                  <option value="45">Denmark +45</option>
                  <option value="253">Djibouti +253</option>
                  <option value="1767">Dominica +1767</option>
                  <option value="1809">Dominican Republic +1809</option>
                  <option value="593">Ecuador +593</option>
                  <option value="20">Egypt +20</option>
                  <option value="503">El Salvador +503</option>
                  <option value="240">Equatorial Guinea +240</option>
                  <option value="291">Eritrea +291</option>
                  <option value="372">Estonia +372</option>
                  <option value="251">Ethiopia +251</option>
                  <option value="500">Falkland Islands (Malvinas) +500</option>
                  <option value="298">Faroe Islands +298</option>
                  <option value="679">Fiji +679</option>
                  <option value="358">Finland +358</option>
                  <option value="33">France +33</option>
                  <option value="594">French Guiana +594</option>
                  <option value="689">French Polynesia +689</option>
                  <option value="262">French Southern Territories +262</option>
                  <option value="241">Gabon +241</option>
                  <option value="220">Gambia +220</option>
                  <option value="995">Georgia +995</option>
                  <option value="49">Germany +49</option>
                  <option value="233">Ghana +233</option>
                  <option value="350">Gibraltar +350</option>
                  <option value="30">Greece +30</option>
                  <option value="299">Greenland +299</option>
                  <option value="1473">Grenada +1473</option>
                  <option value="590">Guadeloupe +590</option>
                  <option value="1671">Guam +1671</option>
                  <option value="502">Guatemala +502</option>
                  <option value="44">Guernsey +44</option>
                  <option value="224">Guinea +224</option>
                  <option value="245">Guinea-Bissau +245</option>
                  <option value="592">Guyana +592</option>
                  <option value="509">Haiti +509</option>
                  <option value="39">Holy See (Vatican City State) +39</option>
                  <option value="504">Honduras +504</option>
                  <option value="852">Hong Kong +852</option>
                  <option value="36">Hungary +36</option>
                  <option value="354">Iceland +354</option>
                  <option value="91">India +91</option>
                  <option value="62">Indonesia +62</option>
                  <option value="98">Iran, Islamic Republic of +98</option>
                  <option value="964">Iraq +964</option>
                  <option value="353">Ireland +353</option>
                  <option value="44">Isle of Man +44</option>
                  <option value="972">Israel +972</option>
                  <option value="39">Italy +39</option>
                  <option value="1876">Jamaica +1876</option>
                  <option value="81">Japan +81</option>
                  <option value="44">Jersey +44</option>
                  <option value="962">Jordan +962</option>
                  <option value="7">Kazakhstan +7</option>
                  <option value="254">Kenya +254</option>
                  <option value="686">Kiribati +686</option>
                  <option value="850">
                    Korea, Democratic People's Republic of +850
                  </option>
                  <option value="82">Korea, Republic of +82</option>
                  <option value="383">Kosovo +383</option>
                  <option value="965">Kuwait +965</option>
                  <option value="996">Kyrgyzstan +996</option>
                  <option value="856">
                    Lao People's Democratic Republic +856
                  </option>
                  <option value="371">Latvia +371</option>
                  <option value="961">Lebanon +961</option>
                  <option value="266">Lesotho +266</option>
                  <option value="231">Liberia +231</option>
                  <option value="218">Libyan Arab Jamahiriya +218</option>
                  <option value="423">Liechtenstein +423</option>
                  <option value="370">Lithuania +370</option>
                  <option value="352">Luxembourg +352</option>
                  <option value="853">Macao +853</option>
                  <option value="389">
                    Macedonia, the Former Yugoslav Republic of +389
                  </option>
                  <option value="261">Madagascar +261</option>
                  <option value="265">Malawi +265</option>
                  <option value="60">Malaysia +60</option>
                  <option value="960">Maldives +960</option>
                  <option value="223">Mali +223</option>
                  <option value="356">Malta +356</option>
                  <option value="692">Marshall Islands +692</option>
                  <option value="596">Martinique +596</option>
                  <option value="222">Mauritania +222</option>
                  <option value="230">Mauritius +230</option>
                  <option value="262">Mayotte +262</option>
                  <option value="52">Mexico +52</option>
                  <option value="691">
                    Micronesia, Federated States of +691
                  </option>
                  <option value="373">Moldova, Republic of +373</option>
                  <option value="377">Monaco +377</option>
                  <option value="976">Mongolia +976</option>
                  <option value="382">Montenegro +382</option>
                  <option value="1664">Montserrat +1664</option>
                  <option value="212">Morocco +212</option>
                  <option value="258">Mozambique +258</option>
                  <option value="95">Myanmar +95</option>
                  <option value="264">Namibia +264</option>
                  <option value="674">Nauru +674</option>
                  <option value="977">Nepal +977</option>
                  <option value="31">Netherlands +31</option>
                  <option value="599">Netherlands Antilles +599</option>
                  <option value="687">New Caledonia +687</option>
                  <option value="64">New Zealand +64</option>
                  <option value="505">Nicaragua +505</option>
                  <option value="227">Niger +227</option>
                  <option value="234">Nigeria +234</option>
                  <option value="683">Niue +683</option>
                  <option value="672">Norfolk Island +672</option>
                  <option value="1670">Northern Mariana Islands +1670</option>
                  <option value="47">Norway +47</option>
                  <option value="968">Oman +968</option>
                  <option value="92">Pakistan +92</option>
                  <option value="680">Palau +680</option>
                  <option value="970">
                    Palestinian Territory, Occupied +970
                  </option>
                  <option value="507">Panama +507</option>
                  <option value="675">Papua New Guinea +675</option>
                  <option value="595">Paraguay +595</option>
                  <option value="51">Peru +51</option>
                  <option value="63">Philippines +63</option>
                  <option value="64">Pitcairn +64</option>
                  <option value="48">Poland +48</option>
                  <option value="351">Portugal +351</option>
                  <option value="1787">Puerto Rico +1787</option>
                  <option value="974">Qatar +974</option>
                  <option value="262">Reunion +262</option>
                  <option value="40">Romania +40</option>
                  <option value="7">Russian Federation +7</option>
                  <option value="250">Rwanda +250</option>
                  <option value="590">Saint Barthelemy +590</option>
                  <option value="290">Saint Helena +290</option>
                  <option value="1869">Saint Kitts and Nevis +1869</option>
                  <option value="1758">Saint Lucia +1758</option>
                  <option value="590">Saint Martin +590</option>
                  <option value="508">Saint Pierre and Miquelon +508</option>
                  <option value="1784">
                    Saint Vincent and the Grenadines +1784
                  </option>
                  <option value="684">Samoa +684</option>
                  <option value="378">San Marino +378</option>
                  <option value="239">Sao Tome and Principe +239</option>
                  <option value="966">Saudi Arabia +966</option>
                  <option value="221">Senegal +221</option>
                  <option value="381">Serbia +381</option>
                  <option value="381">Serbia and Montenegro +381</option>
                  <option value="248">Seychelles +248</option>
                  <option value="232">Sierra Leone +232</option>
                  <option value="65">Singapore +65</option>
                  <option value="721">Sint Maarten +721</option>
                  <option value="421">Slovakia +421</option>
                  <option value="386">Slovenia +386</option>
                  <option value="677">Solomon Islands +677</option>
                  <option value="252">Somalia +252</option>
                  <option value="27">South Africa +27</option>
                  <option value="500">
                    South Georgia and the South Sandwich Islands +500
                  </option>
                  <option value="211">South Sudan +211</option>
                  <option value="34">Spain +34</option>
                  <option value="94">Sri Lanka +94</option>
                  <option value="249">Sudan +249</option>
                  <option value="597">Suriname +597</option>
                  <option value="47">Svalbard and Jan Mayen +47</option>
                  <option value="268">Swaziland +268</option>
                  <option value="46">Sweden +46</option>
                  <option value="41">Switzerland +41</option>
                  <option value="963">Syrian Arab Republic +963</option>
                  <option value="886">Taiwan, Province of China +886</option>
                  <option value="992">Tajikistan +992</option>
                  <option value="255">Tanzania, United Republic of +255</option>
                  <option value="66">Thailand +66</option>
                  <option value="670">Timor-Leste +670</option>
                  <option value="228">Togo +228</option>
                  <option value="690">Tokelau +690</option>
                  <option value="676">Tonga +676</option>
                  <option value="1868">Trinidad and Tobago +1868</option>
                  <option value="216">Tunisia +216</option>
                  <option value="90">Turkey +90</option>
                  <option value="7370">Turkmenistan +7370</option>
                  <option value="1649">Turks and Caicos Islands +1649</option>
                  <option value="688">Tuvalu +688</option>
                  <option value="256">Uganda +256</option>
                  <option value="380">Ukraine +380</option>
                  <option value="971">United Arab Emirates +971</option>
                  <option value="44">United Kingdom +44</option>

                  <option value="1">
                    United States Minor Outlying Islands +1
                  </option>
                  <option value="598">Uruguay +598</option>
                  <option value="998">Uzbekistan +998</option>
                  <option value="678">Vanuatu +678</option>
                  <option value="58">Venezuela +58</option>
                  <option value="84">Viet Nam +84</option>
                  <option value="1284">Virgin Islands, British +1284</option>
                  <option value="1340">Virgin Islands, U.s. +1340</option>
                  <option value="681">Wallis and Futuna +681</option>
                  <option value="212">Western Sahara +212</option>
                  <option value="967">Yemen +967</option>
                  <option value="260">Zambia +260</option>
                  <option value="263">Zimbabwe +263</option>
                </select>
              </div>

              <input
                className="form-control"
                type="tel"
                name="mobile"
                value={formData1.mobile}
                maxLength={10}
                onChange={(e) => {
                  const mobile = e.target.value.replace(/\D/g, "").slice(0, 10);
                  setFormData1({ ...formData1, mobile: mobile });
                }}
                placeholder="Enter Mobile"
              />
            </div>

            <label className="form-label pt-2">
              <b>Address:</b>
            </label>
            <input
              className="form-control"
              type="text"
              name="address"
              value={formData1.address}
              onChange={(e) =>
                setFormData1({ ...formData1, address: e.target.value })
              }
              placeholder="Enter Address"
              required
            />
            <label className="form-label pt-2">
              <b>Country:</b>
            </label>
            <input
              className="form-control"
              type="text"
              name="country"
              value={formData1.country}
              onChange={(e) =>
                setFormData1({ ...formData1, country: e.target.value })
              }
              placeholder="Enter Country"
              required
            />
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal1}>
              Close
            </Button>
            <Button variant="primary" type="submit">
              Update
            </Button>
          </Modal.Footer>
        </form>
      </Modal>

      {/* Delete */}
      <Modal show={showDeleteModal} onHide={handledeleteclose}>
        <Modal.Header>
          <Modal.Title>
            {" "}
            <div className="row">
              <div className="col-lg-2 d-flex justify-content-center pt-2">
                <img
                  className="trash"
                  src={require("../../../assets/img/Admin/bin.png")}
                />
              </div>
              <div className="col-lg-10">
                {" "}
                <p className="popup-delete-text">
                  Are you sure you want to delete ?
                </p>
                <h6>
                  Client Name: <b>{showDeleteModalname}</b>
                </h6>{" "}
              </div>
            </div>{" "}
          </Modal.Title>
        </Modal.Header>

        <Modal.Footer>
          <Button variant="secondary" onClick={handledeleteclose}>
            Close
          </Button>
          <Button variant="danger" type="submit" onClick={handledelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <hr />
      <div class="row">
        <div class="col-md-12">
          {/* <!-- DATA TABLE --> */}

          <div className="d-flex justify-content-between">
            <div className="">
              <label>Show per page:</label>
              <select
                className="form-control"
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>
            </div>
            <form>
              <label>Search :</label>
              <input
                className="form-control"
                type="text"
                onChange={handlesearchFilter}
              ></input>
            </form>
          </div>
          <div class="table-responsive table-responsive-data2 mt-2">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th className="text-center">S.No</th>
                  <th className="text-center">Client Name</th>
                  <th className="text-center">Email</th>
                  <th className="text-center">Mobile</th>
                  {/* <th>Address</th> */}
                  <th className="text-center">Country</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map((item, index) => (
                  <tr key={index}>
                    <td className="desc text-center">
                      {(currentPage - 1) * itemsPerPage + index + 1}
                    </td>

                    <td className="desc text-center">{item.clientName}</td>
                    <td className="desc text-center">{item.email}</td>
                    <td className="desc countrycode text-center">
                      +{item.countrycode} {item.mobile}
                    </td>
                    {/* <td className="desc">{item.address}</td> */}
                    <td className="desc text-center">{item.country}</td>
                    <td className="text-center">
                      <button
                        className="btn btn-button mx-3 px-2 editbutton"
                        onClick={() => handleEdit(item.id)}
                      >
                        <i class="fa-solid fa-pen-to-square"></i>
                      </button>

                      <button
                        className="btn btn-button mx-3  px-2 deletebutton"
                        onClick={() =>
                          handledeletepopup(item.id, item.clientName)
                        }
                      >
                        <i class="fa-solid fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div>
              <nav className="d-flex justify-content-end mx-2 pt-4">
                <ul className="pagination">
                  <li
                    className={`page-item ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link mx-3"
                      onClick={() => paginate(currentPage - 1)}
                    >
                      Previous
                    </button>
                  </li>
                  {Array.from(
                    { length: Math.ceil(filteredData.length / itemsPerPage) },
                    (_, index) => (
                      <li
                        key={index}
                        className={`page-item ${
                          currentPage === index + 1 ? "active" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(index + 1)}
                        >
                          {index + 1}
                        </button>
                      </li>
                    )
                  )}
                  <li
                    className={`page-item ${
                      currentPage ===
                      Math.ceil(filteredData.length / itemsPerPage)
                        ? "disabled"
                        : ""
                    }`}
                  >
                    <button
                      className="page-link mx-3"
                      onClick={() => paginate(currentPage + 1)}
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          {/* <!-- END DATA TABLE --> */}
        </div>
      </div>
    </div>
  );
}

export default ClientDetails;
